import React from 'react';
const LinkedInIcon = ({ fill, width, height, opacity }) => (
    <svg width={width} height={height} viewBox="0 0 30 30">
        <path
            fill={fill}
            opacity={opacity}
            d="M15,0c4.1,0,7.9,1.7,10.6,4.4C28.3,7.1,30,10.9,30,15c0,4.1-1.7,7.9-4.4,10.6C22.9,28.3,19.1,30,15,30
	c-4.1,0-7.9-1.7-10.6-4.4C1.7,22.9,0,19.1,0,15c0-4.1,1.7-7.9,4.4-10.6C7.1,1.7,10.9,0,15,0L15,0z M24.8,5.2c-2.5-2.5-6-4.1-9.8-4.1
	c-3.8,0-7.3,1.5-9.8,4.1c-2.5,2.5-4.1,6-4.1,9.8c0,3.8,1.5,7.3,4.1,9.8c2.5,2.5,6,4.1,9.8,4.1c3.8,0,7.3-1.5,9.8-4.1
	c2.5-2.5,4.1-6,4.1-9.8C28.8,11.2,27.3,7.7,24.8,5.2L24.8,5.2z"
        />
        <path
            fill={fill}
            opacity={opacity}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.2,15.1v6.6h3.2v-7.2v-1.9H8.2V15.1z M21.7,15.5c-0.2-1.7-1-2.8-3.3-2.8c-1.4,0-2.3,0.5-2.6,1.2h0v-1.2h-2.5
	v1.7v7.3h2.6v-4.5c0-1.2,0.2-2.3,1.7-2.3c1.5,0,1.6,1.3,1.6,2.4v4.4h2.7v-5C21.8,16.3,21.7,15.9,21.7,15.5L21.7,15.5z M9.8,8.2
	c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6C11.4,8.9,10.7,8.2,9.8,8.2L9.8,8.2z"
        />
    </svg>
);

export default LinkedInIcon;
